import React, { useState, useRef } from "react";
import "../css/Login.css";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import Logo from "../assets/img/ThinkStore_Logo.png";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("resetEmail");

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 5) inputsRef.current[index + 1]?.focus();
    if (!value && index > 0) inputsRef.current[index - 1]?.focus();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const code = otp.join("");
    if (code.length < 6) {
      showErrorToast(TOAST_MESSAGES.AUTH.ENTER_FULL_OTP);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/verify-otp`,
        { email, otp: code }
      );

      const data = response.data;
      sessionStorage.setItem("resetToken", data.resetToken);

      showSuccessToast(data.message || TOAST_MESSAGES.AUTH.EMAIL_VERIFIED);
      navigate("/reset-password");
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        TOAST_MESSAGES.AUTH.EMAIL_VERIFICATION_FAILED;
      showErrorToast(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left"></div>

      <div className="login-right d-flex flex-column justify-content-center align-items-start">
        {/* Fixed Logo */}
        <div className="mx-auto">
          <img
            src={Logo}
            className="w-80 aspect-[4/1] object-contain"
            alt="Logo"
          />
        </div>

        {/* Form below the logo */}
        <form
          className="login-form p-4 bg-white rounded-3 mx-auto mt-4"
          onSubmit={handleSubmit}
        >
          <h3 className="mb-3 text-center fw-bolder ">
            Enter Verification Code
          </h3>
          <p className="text-center login-p mx-3 text-muted">
            Enter the code that send to your email address
          </p>

          <div className="d-flex justify-content-between mx-4 mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="form-control text-center mx-2 otp-input"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                ref={(el) => (inputsRef.current[index] = el)}
                autoFocus={index === 0}
                disabled={loading}
              />
            ))}
          </div>

          <button
            type="submit"
            className="btn custom-btn w-100"
            disabled={loading}
          >
            {loading ? "Verifying..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyEmail;
